// extracted by mini-css-extract-plugin
module.exports = {"error-label":"FormError_error-label__1Fw70","error":"FormError_error__1DmOj"};